var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextJsBadge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    height: 180,
    id: ":r8:mask0_408_134",
    maskUnits: "userSpaceOnUse",
    width: 180,
    x: 0,
    y: 0,
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    fill: "black",
    r: 90
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#:r8:mask0_408_134)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    "data-circle": "true",
    fill: "transparent",
    r: 90
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.508 157.52L69.142 54H54V125.97H66.1136V69.3836L139.999 164.845C143.333 162.614 146.509 160.165 149.508 157.52Z",
    fill: "url(#:r8:paint0_linear_408_134)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#:r8:paint1_linear_408_134)",
    height: 72,
    width: 12,
    x: 115,
    y: 54
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: ":r8:paint0_linear_408_134",
    x1: 109,
    x2: 144.5,
    y1: 116.5,
    y2: 160.5
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: ":r8:paint1_linear_408_134",
    x1: 121,
    x2: 120.799,
    y1: 54,
    y2: 106.875
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextJsBadge);
export default __webpack_public_path__ + "static/media/next-js-badge.9db6142f8229a6c4bc4349241fa8f254.svg";
export { ForwardRef as ReactComponent };